module.exports = __webpack_public_path__ + "img/nc_bg01.75954a9c.png";